import api from "../api";
import UIComponent from "../ui/component";

export class TranscriptionsUI extends UIComponent {
    init() {
        this.requireComponents({ uploadModal: "document@#upload-modal" });
        this.includeComponents({
            renameFolderModal: "document@#renameFolderModal",
            shareModal: "document@#shareModal",
            ConfirmDeleteModal: "document@#ConfirmDeleteModal",
            moveModal: "document@#moveModal",
            toast: "document@#toast",
        });

        this.setupMoveModalCallbacks();
        this.handleGroup();
        this.setupEventListeners();
        this.checkAndShowToast(); // Добавляем проверку тоста при инициализации
        this.setupUploadModalEvents()

        this.renameFolderBtn?.on("click", () => {
            this.renameFolderModal.id = this.renameFolderBtn.folderid;
            this.renameFolderModal.val = this.renameFolderBtn.val;
            this.renameFolderModal.show();
        });
    }


    setupUploadModalEvents() {
     if (this.uploadModal?.close_upload) {
        this.uploadModal.close_upload.on("click", () => {
            history.replaceState(null, "", window.location.pathname + window.location.search);
            window.location.hash = "";
        });
    }
}

    // Добавляем метод для проверки и показа тоста
    checkAndShowToast() {
        const toastMessage = localStorage.getItem("toastMessage");
        const folderName = localStorage.getItem("folder_name"); 

        if (toastMessage && folderName && this.toast) {
            setTimeout(() => {
                this.toast.show(toastMessage, true, folderName); 
                localStorage.removeItem("toastMessage");
                localStorage.removeItem("folder_name"); 
            }, 100);
        }
    }

    setupMoveModalCallbacks() {
        if (!this.moveModal) {
            console.warn("moveModal component is not available!");
            return;
        }

        this.moveModal.onMove = (folderId) => {
            if (this.moveModal.currentFileId) {
                this.handleSingleFileMove(
                    this.moveModal.currentFileId,
                    folderId
                );
            }
        };

        this.moveModal.setConfirmDialog(
            this?.confirm_dialog || this?.checkbox_show?.confirm_dialog
        );
    }

    handleGroup() {
        this?.rename_folder?.on("click", () => this.showRenameModal());
    }

    setupEventListeners() {
        this.setupShareButtons();
        this.setupSingleFileActions();
        this.uploadBtn?.on("click", () => this.uploadModal?.show());
    }

    setupShareButtons() {
        document.addEventListener("click", (e) => {
            const shareBtn = e.target.closest("[data-transcription-id]");
            shareBtn &&
                this.shareModal?.setTranscriptionId(
                    shareBtn.dataset.transcriptionId
                );
        });
    }

    setupSingleFileActions() {
        this.findAll(
            '[data-bs-target="#moveModal"][data-transcription-id]'
        ).forEach((btn) => {
            btn.addEventListener("click", async (e) => {
                e.preventDefault();
                const fileId = e.currentTarget.dataset.transcriptionId;
                this.moveModal.open(fileId);

                try {
                    const folders = await api.get("/api/folders");
                    this.moveModal.setFolders(folders);
                } catch (err) {
                    console.error("Ошибка загрузки папок:", err);
                }
            });
        });
    }

    async handleSingleFileMove(fileId, folderId) {
        try {
            await api.post(`/api/folders/${folderId}/assign`, {
                ids: [fileId],
            });
        } catch (error) {
            console.error("Move error:", error);
        }
    }

    async loadAndSetFolderTitle() {
        if (this.dinamic_title?.default_folder) {
            this.updateTitle(this.dinamic_title.default_folder);
        }
    }

    saveCurrentFolder(id, name) {
        localStorage.setItem(
            "currentFolder",
            JSON.stringify({ id, name, timestamp: Date.now() })
        );
    }

    showRenameModal() {
        const folderId = new URLSearchParams(window.location.search).get(
            "filters[folder_id]"
        );
        const titleElement = this.find(".h3.mb-0 .text-truncate");
        if (folderId && titleElement && this.renameModal) {
            this.renameModal.open(folderId, titleElement.textContent);
        }
    }

    async handleRenameFolder(folderId, newName) {
        try {
            await api.post(`/api/folders/${folderId}`, { name: newName });
            this.updateTitle(newName);
            this.updateSavedFolderName(folderId, newName);
            return true;
        } catch (error) {
            console.error("Error renaming folder:", error);
            return { error: "Failed to rename folder. Please try again." };
        }
    }

    updateSavedFolderName(folderId, newName) {
        try {
            const folderData = localStorage.getItem("currentFolder");
            if (folderData) {
                const folder = JSON.parse(folderData);
                if (folder?.id === folderId) {
                    folder.name = newName;
                    folder.timestamp = Date.now();
                    localStorage.setItem(
                        "currentFolder",
                        JSON.stringify(folder)
                    );
                }
            }
        } catch (e) {
            console.error("Error updating folder name:", e);
        }
    }

}
